/* ------------------------------------------------------------------
   P7 · Quickview bottom sheet controller.

   Opens from a roster shoe row, shows that rider's size grid, adds to cart
   through the theme's existing cart module. Adds NO behaviour to p7-cart.js
   and edits no existing file.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (window.__p7QuickviewInit) return;
  window.__p7QuickviewInit = true;

  /* Verbatim from p7-product.liquid:1406. Deliberately NOT the selector in
     p7-header.js:66-70, which matches only `a[href], button:not([disabled])`
     and would leave every size radio invisible to the trap. */
  var FOCUSABLE =
    'a[href], area[href], button:not([disabled]), input:not([disabled]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function focusableIn(scope) {
    return Array.prototype.filter.call(scope.querySelectorAll(FOCUSABLE), function (el) {
      return !el.hidden && el.offsetParent !== null;
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* One binding per drawer. A page can carry more than one: the roster page
     renders its own, and the embeddable team carousel renders another wherever
     it is placed. Each root claims only the triggers carrying its own
     data-qv-scope, so two drawers on one page can never open each other's
     panels or collide on data-index, which is per-section and starts at 0. */
  function bindRoot(root, isFirst) {
    var scope = root.getAttribute('data-qv-scope');

    /* Re-parent to body, same reason and same pattern as p7-header.js:62-64:
       a position:fixed element is broken by any transformed ancestor, and the
       snap track is a transform-capable context. */
    if (root.parentElement !== document.body) document.body.appendChild(root);

    var sheet = root.querySelector('[data-qv-sheet]');
    var scrim = root.querySelector('[data-qv-scrim]');
    var closeBtn = root.querySelector('[data-qv-close]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-qv-panel]'));
    if (!sheet || panels.length === 0) return;

    var lastTrigger = null;
    var isOpen = false;

    function showPanel(index) {
      var found = false;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-index') === String(index);
        p.hidden = !on;
        if (on) found = true;
      });
      return found;
    }

    function open(index, trigger) {
      if (!showPanel(index)) return false;
      lastTrigger = trigger || null;
      root.hidden = false;
      document.documentElement.classList.add('p7-qv-open');
      isOpen = true;

      /* Preselect the remembered size, so the pill on the card and the grid
         in the sheet agree. Only ticks a size this product actually offers
         and that is not marked sold out; otherwise the grid opens on its own
         default. Reads the shared store, never writes it. */
      try {
        var api = window.P7SizePrefs;
        var prefs = api && typeof api.read === 'function' ? api.read() : null;
        var want = prefs && prefs.s && prefs.s[0];
        if (want) {
          var panel = root.querySelector('[data-qv-panel]:not([hidden])');
          var radios = panel ? panel.querySelectorAll('input[name="id"][type="radio"]') : [];
          for (var i = 0; i < radios.length; i++) {
            var label = panel.querySelector('label[for="' + radios[i].id + '"]');
            if (!label) continue;
            if (label.getAttribute('data-availability') === 'sold-out') continue;
            if (label.textContent.trim().toUpperCase() !== String(want).trim().toUpperCase()) continue;
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      } catch (e) {
        /* a preselect is a nicety; never let it stop the sheet opening */
      }

      var f = focusableIn(sheet);
      if (f.length) f[0].focus();
      return true;
    }

    function close(opts) {
      if (!isOpen) return;
      isOpen = false;
      root.hidden = true;
      document.documentElement.classList.remove('p7-qv-open');
      panels.forEach(function (p) { p.hidden = true; });

      var restore = !opts || opts.restoreFocus !== false;
      if (restore && lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      lastTrigger = null;
    }

    if (scrim) scrim.addEventListener('click', function () { close(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { close(); });

    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;

      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }

      if (e.key !== 'Tab') return;

      var f = focusableIn(sheet);
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    /* p7-cart.js has no silent-add path: both public entry points end in
       open() (:244, :268). So rather than fight it, stand down when the cart
       drawer takes over. p7:cart-open is the only custom event that file
       dispatches (:218). There is no p7:cart-close. */
    document.addEventListener('p7:cart-open', function () {
      close({ restoreFocus: false });
    });

    /* Triggers: the shoe row on a roster card or a team-carousel card.

       DELEGATED, not bound per node. The team carousel clones its whole card
       set at runtime to loop, and those clones are created after this file
       has run, so per-node listeners would miss every cloned shoe row. One
       listener on the document catches them all and survives any later DOM
       change.

       A trigger with no scope attribute belongs to the first drawer only,
       which keeps markup written before scoping existed working unchanged. */
    document.addEventListener('click', function (e) {
      var el = e.target;
      if (!el || typeof el.closest !== 'function') return;
      var row = el.closest('[data-roster-shoe], [data-qv-trigger]');
      if (!row) return;

      var rowScope = row.getAttribute('data-qv-scope');
      if (rowScope ? rowScope !== scope : !isFirst) return;

      // Only intercept if a panel exists for this rider; otherwise let the
      // link navigate to the product page as it would with no JS.
      if (open(row.getAttribute('data-index'), row)) e.preventDefault();
    });

    /* Add to cart */
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('.p7-qv__form');
      if (!form) return;
      e.preventDefault();

      var checked = form.querySelector('input[name="id"]:checked');
      var fallback = form.querySelector('[data-qv-variant-id]');
      var input = checked || fallback;
      if (!input) return;

      /* The shared size grid marks unavailable sizes on the LABEL and never
         disables the input (p7-pdp-size-grid.liquid:53-56), so a sold-out size
         is fully selectable. Refuse it here. */
      if (checked) {
        var label = form.querySelector('label[for="' + checked.id + '"]');
        if (label && label.getAttribute('data-availability') === 'sold-out') return;
      }

      var id = input.value;
      var btn = form.querySelector('[data-qv-add]');
      if (btn) btn.disabled = true;

      function done() { if (btn) btn.disabled = false; }

      /* p7-cart.js is defer-loaded from p7-header.liquid:463, so the guard is
         mandatory, not decorative. addItems resolves to undefined, so do not
         read a return value. properties: null is accepted (p7-cart.js:254). */
      if (window.P7Cart && typeof window.P7Cart.addItems === 'function') {
        Promise.resolve(window.P7Cart.addItems([{ id: id, quantity: 1, properties: null }]))
          .then(done, done);
        return;
      }
      if (window.P7Cart && typeof window.P7Cart.add === 'function') {
        Promise.resolve(window.P7Cart.add(id, 1)).then(done, done);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function () { window.location.href = '/cart'; })
        .catch(done);
    });

    if (isFirst) window.P7Quickview = { open: open, close: close };
  }

  ready(function () {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-p7-qv]'),
      function (root, i) { bindRoot(root, i === 0); }
    );
  });
})();
